<template>
    <div>
        <div class="sticky-sidebar-right bg-white w3-animate-right" style="width: 300px;" v-if="pode_exibir">

            <az-loading msg="Carregando..." v-if="$store.state.loading && !historico_carregado" /> 

            <div class="px-2" v-else>

                <div>
                    <az-input
                        sizing="sm"
                        icon="fa fa-search"
                        placeholder="Pesquisar..."
                        v-model="search_historico" 
                        @input="conteudo = null; selecionado = null;">
                        <template v-slot:buttonposb>
                            <div class="input-group-append">
                                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="abrir_perfil()" title="Abrir histórico do paciente">
                                    <i class="fas fa-id-badge"></i>
                                </button>
                                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="toggle_exibir_todos()" title="Expandir/comprimir todos">
                                    <i class="fa-solid fa-maximize"></i>
                                </button>
                                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="fechar_historico()" title="Fechar histórico">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </button>
                                <!-- 
                                    <print-export sizing="sm" printid="historico-resumo" />
                                -->
                            </div>
                        </template>
                    </az-input>
                </div>

                <div id="historico-resumo">

                    <!--
                    <cabecalho-generico titulo="Histórico">
                    <div>Paciente: {{ atendimento.paciente.st_nome }}</div>
                    <div>Data: {{ $util.getFormatDate($util.hoje()) }}</div>
                    </cabecalho-generico>
                    -->

                    <div class="card">
                        <template v-for="(marcacao, iix) in lista_historico_exibicao.marcacoes">
                            <template v-if="force_laudos || !atendimento || ( marcacao.id_atendimento != atendimento.id_atendimento )">
                                <div class="list-group-item list-group-item-info p-2" :key="iix">
                                    <div class="small d-flex justify-content-between">
                                        <span>{{ getHumanDate(marcacao.dt_inicio) }}</span>
                                        <span class="ml-2 d-print-none">
                                            {{ getHumanDuration(marcacao.dt_inicio) }}
                                            <a href="#" @click.prevent="abrir_item(marcacao)" class="ml-2" title="Ver Detalhe Expandido.">
                                                <i class="fa-solid fa-expand"></i>
                                            </a>
                                        </span>
                                    </div>
                                    <div class="small">
                                        <a href="#" @click.prevent="toggle_exibir(marcacao)" class="card-link">
                                            {{ marcacao.procedimento.search }}
                                        </a>
                                    </div>
                                    <div class="small">
                                        {{ marcacao.medico.st_nome_exibicao }}
                                    </div>
                                    <div class="small" v-if="marcacao.atendimento && marcacao.atendimento.cid">
                                        CID: {{ marcacao.atendimento.cid.st_codigo }}
                                    </div>
                                </div>
                                <template v-if="marcacao.exibir && marcacao.atendimento && marcacao.atendimento.atendimento_procedimentos">
                                    <div v-for="(atp, itx) in marcacao.atendimento.atendimento_procedimentos" :key="iix + '.' + itx"> 

                                        <div v-if="itx" class="mb-3 alert alert-info p-1 small">
                                            {{ atp.procedimento.search }}
                                        </div>

                                        <div class="mb-3" v-if="!atp.laudo">
                                            <formulario 
                                                :onecol="true"
                                                v-model="atp.anamnese.dados" 
                                                mode="view" 
                                                :view_with_print="false" 
                                                tamanho="P" 
                                                :secundario="marcacao.id_procedimento != atp.id_procedimento || ( marcacao.atendimento.registros && marcacao.atendimento.registros.length )" 
                                                v-if="atp.anamnese" />
                                        </div>

                                        <div class="mb-3" v-else-if="resumo_com_laudo && atp.laudo">
                                            <div v-if="atp.laudo.partes && atp.laudo.partes.length">
                                                <div v-for="(parte, ipx) in atp.laudo.partes" :key="ipx">
                                                    <formulario 
                                                        :show_boxes="false"
                                                        :onecol="true"
                                                        v-model="parte.st_conteudo" 
                                                        mode="view" 
                                                        :view_with_print="false" 
                                                        tamanho="P" />
                                                    <hr>
                                                </div>
                                            </div>

                                            <template v-else>
                                                <formulario 
                                                    :onecol="true"
                                                    v-model="atp.laudo.dados" 
                                                    mode="view" 
                                                    :view_with_print="false" 
                                                    tamanho="P" 
                                                    :secundario="marcacao.id_procedimento != atp.id_procedimento" 
                                                    v-if="atp.laudo" />
                                            </template>
                                        </div>

                                        <template v-if="marcacao.atendimento.registros && marcacao.atendimento.registros.length">

                                            <div v-for="(registro, iregx) in marcacao.atendimento.registros" :key="iregx">
                                                <div v-if="registro.st_conteudo && registro.st_conteudo.length">
                                                    <az-sub-title :title="titulo_registro(registro)">
                                                    </az-sub-title>

                                                    <campos-formulario 
                                                        v-model="registro.st_conteudo" 
                                                        :raiz="true" 
                                                        mode="view"
                                                        :compact="registro.modelo.fl_compact" />
                                                </div>
                                            </div>

                                        </template>
                                    </div>
                                </template>
                            </template>
                        </template>

                        <!-- Lista de Atendimentos Legados -->
                        <template v-for="(item, iix) in lista_historico_exibicao.legado">
                            <div  v-if="item.st_tipo == '1'" :key="'leg' + iix">
                                <div class="list-group-item list-group-item-info p-2" :key="'legado' + iix">
                                    <div class="small d-flex justify-content-between">
                                        <div>{{ getHumanDate(item.dt_data) }}</div>
                                        <div class="text-right">
                                            <small class="ml-2">{{ getHumanDuration(item.dt_data) }}</small>
                                            <i class="fas fa-history ml-2"></i>
                                            <a href="#" @click.prevent="abrir_item(item)" class="ml-2" title="Ver Detalhe Expandido.">
                                                <i class="fa-solid fa-expand"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="small">
                                        <a href="#" @click.prevent="toggle_exibir(item)" class="card-link">
                                            {{ item.st_descricao }}
                                        </a>
                                    </div>
                                    <div class="small">{{ item.st_nome_medico }}</div>
                                </div>
                                <div class="p-1" :key="'legado-cont' + iix" v-if="item.exibir">
                                    <span v-html="item.st_conteudo" class="small"></span>

                                    <div v-if="item.arquivos && item.arquivos.length" class="small mt-2">
                                        <i class="fa-solid fa-paperclip"></i>
                                        {{ item.arquivos.length }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>

                    <br><br><br><br><br>

                </div>
            </div>
        </div>

        <!-- Ver Detalhe -->
        <div class="modal fade" id="historicoItemModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Visualização</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <!-- Exibição de Item de Marcação -->
                        <div v-if="item_modal && item_modal.id_marcacao">
                            <div class="list-group-item list-group-item-info">
                                <div class="small d-flex justify-content-between">
                                    <span>{{ getHumanDate(item_modal.dt_inicio) }}</span>
                                    <span class="ml-2 d-print-none">
                                        {{ getHumanDuration(item_modal.dt_inicio) }}
                                    </span>
                                </div>
                                <div class="small">
                                    {{ item_modal.procedimento.search }}
                                </div>
                                <div class="small">
                                    {{ item_modal.medico.st_nome_exibicao }}
                                </div>
                                <div class="small" v-if="item_modal.atendimento && item_modal.atendimento.cid">
                                    CID: {{ item_modal.atendimento.cid.st_codigo }}
                                </div>
                            </div>
                            <div class="list-group-item" v-for="(atp, itx) in item_modal.atendimento.atendimento_procedimentos" :key="iix + '.' + itx"> 

                                <div v-if="itx" class="mb-3 alert alert-info p-1 small">
                                    {{ atp.procedimento.search }}
                                </div>

                                <div class="mb-3" v-if="!atp.laudo">
                                    <formulario 
                                        :onecol="true"
                                        v-model="atp.anamnese.dados" 
                                        mode="view" 
                                        :view_with_print="false" 
                                        tamanho="P" 
                                        :secundario="item_modal.id_procedimento != atp.id_procedimento || ( item_modal.atendimento.registros && item_modal.atendimento.registros.length )" 
                                        v-if="atp.anamnese" />
                                </div>

                                <div class="mb-3" v-else-if="resumo_com_laudo && atp.laudo">
                                    <formulario 
                                        :onecol="true"
                                        v-model="atp.laudo.dados" 
                                        mode="view" 
                                        :view_with_print="false" 
                                        tamanho="P" 
                                        :secundario="item_modal.id_procedimento != atp.id_procedimento" 
                                        v-if="atp.laudo" />
                                </div>

                                <template v-if="item_modal.atendimento.registros && item_modal.atendimento.registros.length">

                                    <div v-for="(registro, iregx) in item_modal.atendimento.registros" :key="iregx">
                                        <div v-if="registro.st_conteudo && registro.st_conteudo.length">
                                            <az-sub-title :title="titulo_registro(registro)">
                                            </az-sub-title>

                                            <campos-formulario 
                                                v-model="registro.st_conteudo" 
                                                :raiz="true" 
                                                mode="view"
                                                :compact="registro.modelo.fl_compact" />
                                        </div>
                                    </div>

                                </template>
                            </div>
                        </div>

                        <!-- Exibição de Item de Prontuario Legado -->
                        <template v-if="item_modal && item_modal.id_prontuario_legado">
                            <div class="list-group-item list-group-item-info">
                                <div class="small d-flex justify-content-between">
                                    <div>{{ getHumanDate(item_modal.dt_data) }}</div>
                                    <div>
                                        <small class="ml-2">{{ getHumanDuration(item_modal.dt_data) }}</small>
                                        <i class="fas fa-history ml-2"></i>
                                    </div>
                                </div>
                                <div class="small">
                                    {{ item_modal.st_descricao }}
                                </div>
                                <div class="small">{{ item_modal.st_nome_medico }}</div>
                            </div>
                            <div class="mb-3 list-group-item">
                                <span v-html="item_modal.st_conteudo"></span>
                                <template v-if="item_modal.arquivos && item_modal.arquivos.length">
                                    <ver-arquivos-rolagem class="mt-1" :arquivos="item_modal.arquivos" />
                                </template>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer" v-if="false">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import * as moment from "moment";
import AzLoading from '../../util/AzLoading.vue';
import Formulario from "./Formulario.vue";
import CamposFormulario from "./CamposFormulario.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubTitle from "../../util/AzSubTitle.vue";
import VerArquivosRolagem from './VerArquivosRolagem.vue';

export default {
    data() {
        return { 
            id_paciente: null, 
            lista_historico: null, 
            resumo_com_laudo: false, 
            historico_carregado: false, 
            pode_exibir: false,
            search_historico: "", 
            exibir_todos: false, 
            item_modal: null, 
        }
    },

    props: ['atendimento', 'force_laudos'], 

    components: { 
        AzLoading, 
        Formulario, 
        CamposFormulario, 
        AzInput, 
        AzSubTitle, 
        VerArquivosRolagem,
    }, 

    computed: { 
        lista_historico_exibicao: function () { 
            if ( !this.search_historico )
                return this.lista_historico;

            let reg = this.$util.getregex(this.search_historico);

            let teste = { 
                marcacoes: this.lista_historico.marcacoes.filter(item => { 

                    if ( !this.search_historico )
                        return true;

                    let descr = "";

                    if ( this.busca_avancada ) { 
                        switch (this.filtro_avancado_historico) {
                            case 'P':
                                if ( item.atendimento && item.atendimento.atendimento_procedimentos ) { 
                                    descr = item.atendimento.atendimento_procedimentos.map(item => item.procedimento.search).join(',');
                                } else { 
                                    descr = item.procedimento.search;
                                }    
                                break;

                            case 'M':
                                descr = item.medico.search;
                                break;
                        }             
                    } 

                    return ( ( this.atendimento && item.id_atendimento == this.atendimento.id_atendimento ) ) 
                        || ( ( !this.busca_avancada || this.filtro_avancado_historico == 'G' ) && reg.test(JSON.stringify(item)))
                        || ( this.busca_avancada 
                            && this.filtro_avancado_historico != 'G' 
                            && descr 
                            && reg.test(descr)
                        );
                }),

                legado: this.lista_historico.legado.filter(item => { 
                    if ( !this.search_historico )
                    return true;
                    
                    let descr = "";

                    if ( this.busca_avancada ) { 
                    switch (this.filtro_avancado_historico) {
                        case 'P':
                        descr = item.st_descricao;
                        break;

                        case 'M':
                        descr = item.st_nome_medico;
                        break;
                    }             
                    } 

                    return ( !this.busca_avancada && reg.test(JSON.stringify(item)) )
                    || ( this.busca_avancada && descr && reg.test(descr));
                }),
                };

            return teste;
        },
    },

    methods: { 
        abrir_item (item) { 
            this.item_modal = item;
            $("#historicoItemModal").modal("show");
        },

        toggle_exibir_todos () { 
            this.exibir_todos = !this.exibir_todos;

            this.lista_historico.marcacoes.forEach(item => { 
                item.exibir = this.exibir_todos;
            });

            this.lista_historico.legado.forEach(item => { 
                item.exibir = this.exibir_todos;
            });
            
            this.$forceUpdate();
        },

        toggle_exibir(marcacao) { 
            marcacao.exibir = !marcacao.exibir;
            console.log('ll', this.lista_historico_exibicao);
            this.$forceUpdate();
        },

        abrir_perfil() { 
            this.$root.perfil(this.atendimento.paciente);
        },

        fechar_historico() { 
            console.log('h', this.lista_historico_exibicao);
            this.$emit("fechar"); 
            // return this.pode_exibir = false;
        },

        abrir(id_paciente) { 
            this.pode_exibir = true;

            if ( this.lista_historico === null || this.id_paciente != id_paciente ) { 
                this.id_paciente = id_paciente; 
                this.carregar_historico();
            }
        },

        carregar_historico () { 

            this.$store.commit("loading", true);
            this.loading = true;
            let query = { q: [] };

            query = {
                q: [
                    {
                        name: "marcacoes.index",
                        id: "marcacoes",
                        parms: { id_paciente: this.id_paciente }
                    },
                    {
                        name: "pep.legado",
                        id: "legado",
                        parms: { id_paciente: this.id_paciente }
                    },
                    {
                        name: "pep.avulsos",
                        id: "avulsos",
                        parms: { id_paciente: this.id_paciente }
                    },
                    {
                        name: "configuracoes.index",
                        id: "resumolaudo",
                        parms: { 
                            where: { 
                            st_slug: 'pep-resumo-com-laudo',
                            st_valor: '1', 
                            }
                        }
                    },
                ]
            };

            this.axios
                .post("/aql?a=pep.load", query)
                .then(res => {
                    this.lista_historico = {};

                    this.lista_historico.marcacoes = res.data.marcacoes.data.map(item => { 
                        item.exibir = false; 
                        return item;
                    });

                    this.lista_historico.legado = res.data.legado 
                        ? res.data.legado.data.map(item => { 
                                item.exibir = false; 
                                return item;
                            }) 
                        : null;
                    
                    if ( res.data.avulsos && res.data.avulsos.data.length ) { 
                        this.lista_historico.marcacoes = _.orderBy(
                            this.lista_historico.marcacoes.concat(res.data.avulsos.data),
                            'dt_inicio',
                            'desc'
                        );
                    }

                    if ( this.force_laudos || ( res.data.resumolaudo && res.data.resumolaudo.data.length ) ) { 
                        this.resumo_com_laudo = true;
                    }
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                    this.historico_carregado = true; 
                    this.$forceUpdate();
                });

        },

        getHumanDay(date) {
            return moment(date, "YYYY-MM-DD").format("dddd");
        },

        getHumanDate(date) {
            return (
                moment(date, "YYYY-MM-DD").format("DD") +
                " de " +
                moment(date, "YYYY-MM-DD").format("MMMM") +
                (moment(date, "YYYY-MM-DD").format("YYYY") == new Date().getFullYear()
                ? ""
                : " de " + moment(date, "YYYY-MM-DD").format("YYYY"))
            );
        },
        getHumanDuration(date) {
            if (date.substr(0, 10) == this.$util.hoje()) return "hoje";
            else {
                moment.relativeTimeRounding(Math.floor);
                return moment
                    .duration(moment(date, "YYYY-MM-DD").diff(this.$util.hoje()))
                    .humanize(true);
            } 
        },

    }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.sticky-sidebar {
  height: 100%; /* Full-height: remove this if you want "auto" height */
  width: 160px; /* Set the width of the sidebar */
  position: fixed; /* Fixed Sidebar (stay in place on scroll) */
  z-index: 1; /* Stay on top */
  top: 0; /* Stay at the top */
  left: 0;
  background-color: #111; /* Black */
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 116px;
}

.sticky-sidebar-right {
  height: 100%; /* Full-height: remove this if you want "auto" height */
  width: 160px; /* Set the width of the sidebar */
  position: fixed; /* Fixed Sidebar (stay in place on scroll) */
  z-index: 1; /* Stay on top */
  top: 0; /* Stay at the top */
  right: 0;
  background-color: #111; /* Black */
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 116px;
}
</style>
